import React from 'react';
import { motion } from "framer-motion";
import { HashLink as Link } from 'react-router-hash-link';

const fadeInVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
};

const AboutUs = () => {
  return (
    <div className="flex flex-col md:flex-row font-sans bg-[#427dfc1c] text-black px-6 md:px-16 pt-10 md:pt-20 pb-32 gap-16 justify-center items-start">
      {/* Left: Heading + Text */}
      <motion.div
        className="w-full md:w-1/2 flex flex-col justify-start order-1 md:order-1 max-w-md mt-10"
        variants={fadeInVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <h2 className="text-3xl font-medium text-black sm:text-4xl">
          About Us
        </h2>
        <p className="mt-4 text-gray-600 text-lg">
          Created with clinical teams in mind, Cura AI streamlines the routine so you can
          focus on what matters most—patient care. Seamless integration ensures it works
          with the tools you're already using.
        </p>
        <div className="mt-4">
          <Link smooth to="/#pricing" className="text-blue-500 hover:text-blue-600 font-medium">
            Learn more about us <span className="ml-2">&#8594;</span>
          </Link>
        </div>
      </motion.div>

      {/* Right: Image */}
      <div className="w-full md:w-1/2 order-2 md:order-2 flex flex-col items-center mt-10">
        <motion.div
          className="bg-white rounded-xl shadow-xl overflow-hidden w-full h-auto"
          variants={fadeInVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <img
            src="https://images.unsplash.com/photo-1531973576160-7125cd663d86"
            alt="Cura AI"
            className="w-full h-full object-cover"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;